module.exports = __webpack_public_path__ + "static/mumbai-8948a57c37d101577df464858c5cc3c4.jpg";